import memberStore from './MemberStore';
import drugStore from './DrugStore';

export default {
  member: memberStore,
  drug: drugStore,
};
